import { Link } from "react-router-dom";
import { categories, comics } from "@/mocks/comics";

export default function CategorySection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-3 text-center">
          <span className="text-sm font-medium tracking-wide text-primary-500">按喜好分类</span>
          <h2 className="font-heading text-3xl text-foreground-900">总有一款适合你</h2>
          <p className="mx-auto max-w-xl text-sm text-foreground-500">
            萌系、甜宠、恋爱三大分类，软萌角色与甜蜜剧情随心挑选，分类清晰不迷路。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {categories.map((c) => {
            const count = comics.filter((x) => x.category === c.name).length;
            return (
              <Link
                key={c.key}
                to={`/category/${c.key}`}
                className="group flex flex-col gap-4 rounded-2xl bg-background-100 p-6 transition-colors hover:bg-primary-50"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className={`${c.icon} text-2xl`} />
                  </span>
                  <span className="rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-500 group-hover:bg-background-50">
                    {count}部精选
                  </span>
                </div>
                <div>
                  <h3 className="text-lg font-medium text-foreground-900">{c.name}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{c.desc}</p>
                </div>
                <span className="flex items-center gap-1 text-sm text-primary-600">
                  去逛逛
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}